export default {
  serviceCompany: {
    companyName: '',
    oftecRegistration: '',
    engineerName: '',
    engineerCardNumber: '',
    telephone: ''
  },
  customer: {
    customerName: '',
    siteAddress: '',
    postCode: '',
    applianceType: '',
    make: '',
    model: '',
    serialNumber: '',
    burnerMake: '',
    burnerModel: ''
  },
  nozzle: {
    nozzleSize: '',
    nozzleAngle: '',
    nozzlePattern: '',
    pumpPressureBar: '',
    vacuumReadingMbar: '',
    oilLineCondition: '',
    oilFilter: ''
  },
  combustion: {
    combustionTestPerformed: '',
    o2Pct: '',
    co2Pct: '',
    coPpm: '',
    flueTempC: '',
    ambientTempC: '',
    smokeNumber: '',
    flueCondition: ''
  },
  servicing: {
    burnerCleaned: '',
    heatExchangerCleaned: '',
    electrodesChecked: '',
    nozzleReplaced: '',
    fireValveTested: '',
    fireValveTripC: '',
    scopeOfService: '',
    faultsFound: '',
    workCarriedOut: ''
  },
  certification: {
    serviceDate: '',
    certificateNumber: '',
    engineerSignature: '',
    engineerPrint: '',
    customerSignature: '',
    customerPrint: ''
  }
};
